<h2>Wage Sustainability Report (Based on the last 4 weeks)</h2>

Total Revenue: {{totalRevenue | human: true}} pw<br>
Total Expense: {{totalExpense | human: true}} pw<br><br>
Total Profit: {{totalProfit | human: true}} pw<br>
Total Wages: {{totalWages | human: true}} pw<br><br>

Difference: {{netDifference | human: true}} pw